export default {
    back:"当前用户无数据，请联系国教院0577-86699031",
    YJSProofOfReading:{
        copysuccess:"复制成功",
        copysuccesstext:"在新页面中打开下载",
        copyfail:"复制失败",
        copyfailtext:"在新页面中打开"
    },
    valiform:{
        welcome:'欢迎',
        title:"自助表单验证",
        code:"验证码",
        valid:"校验",
        name:"姓名",
        jobno:"工号",
        filename:"文件名称",
        creatime:"创建时间",
        secretcode:"密钥",
        download:"下载",
        see:"预览",
        required:"必要"
    }  
}